import { render, staticRenderFns } from "./MenuPanel.vue?vue&type=template&id=2e2bb93e&scoped=true&"
import script from "./MenuPanel.vue?vue&type=script&lang=js&"
export * from "./MenuPanel.vue?vue&type=script&lang=js&"
import style0 from "./MenuPanel.vue?vue&type=style&index=0&id=2e2bb93e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2bb93e",
  null
  
)

export default component.exports